// extracted by mini-css-extract-plugin
export var typingIndicator = "_js-0";